import { SchemaType } from "@redotech/redo-model/advanced-flow/schemas/schemas";
import * as z from "zod/v4";

export const generateSmsAiContentPreview = {
  name: "generateSmsAiContentPreview" as const,
  input: z.object({
    schemaType: z.enum(SchemaType),
    contentGeneratorConfigVersionId: z.string(),
    customerId: z.string().optional(),
    templateId: z.string(), // Add templateId to access template settings
  }),
  output: z.object({
    data: z.object({
      contentPreview: z.string(),
      metrics: z.array(z.string()),
      reasoning: z.string(),
    }),
  }),
};
